export default __webpack_public_path__ + "static/media/game_2_l.0e4a2130.png";